export default "__VITE_ASSET__DOwbPh7B__"